import React from 'react'
import PropTypes from 'prop-types'
import { Box, Chip, Paper, Stack, Typography } from '@mui/material'

const STATUS_COLOR = {
  healthy: 'success',
  warning: 'warning',
  critical: 'error',
  neutral: 'default',
}

export default function OperationalKpiCard({
  title,
  value,
  subtitle,
  status = 'neutral',
  icon,
}) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 3,
        height: '100%',
        bgcolor: 'background.paper',
      }}
    >
      <Stack spacing={1.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          {icon && <Box sx={{ color: 'text.secondary', display: 'flex' }}>{icon}</Box>}
        </Stack>
        <Typography variant="h4" sx={{ fontWeight: 800, lineHeight: 1 }}>
          {value}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
        <Chip
          size="small"
          label={status}
          color={STATUS_COLOR[status] || STATUS_COLOR.neutral}
          sx={{ alignSelf: 'flex-start', textTransform: 'capitalize' }}
        />
      </Stack>
    </Paper>
  )
}

OperationalKpiCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string,
  status: PropTypes.string,
  icon: PropTypes.node,
}
